import React from 'react';

const MatchDescriptionTable = ({ eventDetails, leagues }) => {
  const {
    matchId, seasonId, leagueId, roundId,
  } = eventDetails;

  const selectedLeague = leagues.find((l) => l.id === leagueId);

  return (
    <div className="table-responsive m-t-30">
      <table className="match">
        <thead className="thead--green">
          <tr>
            <th className="match__th">Match ID</th>
            <th>Round</th>
            <th>Season ID</th>
            <th className="match__th">League</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{matchId}</td>
            <td>{roundId}</td>
            <td>{seasonId}</td>
            <td>{selectedLeague.name}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MatchDescriptionTable;
